import styled from "styled-components";

export const StyledEditor = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
  border: 1px solid ${(props) => props.theme.colors.primary.lightest};
  border-radius: ${(props) => props.theme.radius.normal};
  background-color: ${(props) => props.theme.colors.primary.dark};
`;

export const StyledEditorContent = styled.div.attrs((props) => ({
  style: {
    transform: `translate(${props.$position.x}px, ${props.$position.y}px) scale(${props.scale})`,
  },
}))`
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;
`;

export const StyledEditorBackground = styled.div.attrs((props) => ({
  style: {
    backgroundPosition: `${props.$position.x}px ${props.$position.y}px`,
    backgroundSize: `${20 * props.scale}px ${20 * props.scale}px`,
  },
}))`
  position: absolute;
  transform-origin: top left;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
      to right,
      rgba(125, 125, 125, 0.15) 1px,
      transparent 1px
    ),
    linear-gradient(to bottom, rgba(125, 125, 125, 0.15) 1px, transparent 1px);
`;

export const StyledEditorControls = styled.div`
  padding: ${(props) => props.theme.spacing.normal};
  border-radius: ${(props) => props.theme.radius.normal};
  background-color: rgba(0, 0, 0, 0.33);
`;

export const StyledEditorZoomIndicator = styled.div`
  background-color: ${(props) => props.theme.colors.primary.lightest};
  border-radius: ${(props) => props.theme.radius.normal};
  padding: ${(props) => props.theme.spacing.normal};
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.normal};
  opacity: ${(props) => (props.disabled ? 0.33 : 1)};
`;
